import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AmountPipe } from '../../pipes/amount.pipe';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIcon,
    MatButton,
    AmountPipe
  ],
  selector: 'equine-ui-nx-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss']
})
export class OrderSummaryComponent implements OnChanges {

  @Input() subtotal = 0;
  @Input() subtotalCount = 0;
  @Input() coupon = 0;
  @Input() donation = 0;
  @Input() total = 0;

  @Output() goBack = new EventEmitter<void>();

  displayedColumns: string[] = ['description', 'cost'];

  summary: {item: string, cost: number}[] = [];

  ngOnChanges() {
    this.summary = [
      {item: `Order Subtotal (${this.subtotalCount} Items)`, cost: this.subtotal},
      {item: 'Coupon Codes Discounts', cost: this.coupon},
      {item: 'Donation', cost: this.donation},
    ];
  }

  back() {
    this.goBack.emit();
  }

}
